// @flow
import * as React from 'react';
import { memoize } from 'lodash';

import { APP_EVENTS } from 'Components/utils/responsive/constants';

import { getCurrentBreakpoint } from './Responsive.helper.js';
import { subscribe, unsubscribe } from './Responsive.listener.js';
import Responsive from './responsiveContext';

import getCurrentResponsive from './getCurrentResponsive';

// prevent rerender of all component using ResponsiveContext when the breakpoint doesn't change
const memoizedGetCurrentResponsive = memoize(getCurrentResponsive);

type Props = {|
  children: React.Node,
  userAgent?: string,
|};

type State = {
  currentBreakpoint: Breakpoint,
  isAppMounted: boolean,
};

function sendEvent(name) {
  let event;

  if (typeof Event === 'function') {
    event = new Event(name);
  } else {
    event = document.createEvent('Event');
    event.initEvent(name, true, true);
  }

  document.dispatchEvent(event);
}

export class ResponsiveLayout extends React.Component<Props, State> {
  state = {
    currentBreakpoint: getCurrentBreakpoint(this.props.userAgent || '', false),
    isAppMounted: false,
  };

  constructor(props: Props) {
    super(props);

    if (typeof window !== 'undefined' && !window.cmAppMounted) {
      sendEvent(APP_EVENTS.MOUNTING);
    }
  }

  componentDidMount() {
    subscribe(this);

    this.setState({
      currentBreakpoint: getCurrentBreakpoint(this.props.userAgent || '', true),
      isAppMounted: true,
    });

    if (!window.cmAppMounted) {
      // Dispatch the info that the app is mounted
      window.cmAppMounted = true;
      sendEvent(APP_EVENTS.MOUNTED);
    }
  }

  componentWillUnmount() {
    unsubscribe(this);
  }

  render() {
    const { children } = this.props;
    const { currentBreakpoint, isAppMounted } = this.state;

    return (
      <Responsive.Provider
        value={memoizedGetCurrentResponsive({ currentBreakpoint, isAppMounted })}
      >
        {children}
      </Responsive.Provider>
    );
  }
}
